module.exports = __webpack_public_path__ + "assets/drupal.6c0717c2.svg";